<div class="content-layout fullwidth-standard-normal-scroll h-full">
  <div class="header">
    <div class="container">
      <h1>Apps & Integrations</h1>
    </div>
  </div>

  <div class="flex w-full h-full rich-text">
    <ng-container *ngIf="accountIntegrations$ | async as accountIntegrations; else LoadingOrError">
      <table class="w-full treo-table bg-white">
        <thead>
          <tr>
            <th class="mat-header-cell bg-cool-gray-50 dark:bg-cool-gray-700 border-t">Name</th>
            <th class="mat-header-cell bg-cool-gray-50 dark:bg-cool-gray-700 border-t">Description</th>
            <th class="mat-header-cell bg-cool-gray-50 dark:bg-cool-gray-700 border-t">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr class="mat-row cdk-row order-row h-10" *ngFor="let accountIntegration of accountIntegrations">
            <td>
              <span class="pl-3">{{ accountIntegration.integration.name }}</span>
            </td>
            <td>
              <ng-container
                *ngIf="
                  accountIntegration.integration.slug === 'procore' &&
                  (accountIntegration.user_id
                    ? accountIntegration.integration.new_connections_enabled &&
                      accountIntegration.user_id == currentUser.id &&
                      accountIntegration.active
                    : accountIntegration.integration.new_connections_enabled && accountIntegration.active)
                "
              >
                <select class="dropdown-menu-wrapper">
                  <option [value]="">--Select Company--</option>
                  <option value="1234">TermSheet</option>
                  <option [value]="1235">Termsheet2</option>
                  <option [value]="1235">Termsheet3</option>
                </select>
              </ng-container>
              <ng-container *ngIf="accountIntegration.integration.slug !== 'procore'">
                {{ accountIntegration.integration.description }}
              </ng-container>
            </td>
            <td>
              <button
                class="px-6 mt-8"
                mat-flat-button
                [color]="'primary'"
                (click)="connectIntegration(accountIntegration)"
                *ngIf="
                  accountIntegration.user_id
                    ? accountIntegration.integration.new_connections_enabled &&
                      !(accountIntegration.user_id == currentUser.id && accountIntegration.active)
                    : accountIntegration.integration.new_connections_enabled && !accountIntegration.active
                "
              >
                Connect
              </button>
              <button
                class="px-6 mt-8"
                mat-flat-button
                [color]="'primary'"
                (click)="connectIntegration(accountIntegration)"
                *ngIf="
                  accountIntegration.user_id
                    ? accountIntegration.integration.new_connections_enabled &&
                      accountIntegration.user_id == currentUser.id &&
                      accountIntegration.active
                    : accountIntegration.integration.new_connections_enabled && accountIntegration.active
                "
              >
                Reconnect
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </ng-container>
  </div>
</div>

<ng-template #LoadingOrError>
  <ng-container *ngIf="accountIntegrationsError$ | async as error; else Loading">
    <section class="w-full h-full flex flex-col justify-center items-center">
      <h1>Oops! Something went wrong...</h1>
      <h4 [innerText]="error.message"></h4>
    </section>
  </ng-container>
  <ng-template #Loading>
    <mat-progress-bar [mode]="'indeterminate'"></mat-progress-bar>
  </ng-template>
</ng-template>
